import { useEffect, useState } from 'preact/hooks';
import { getCookie, setCookie } from 'utils/helpers';

const technicalDataEl = document.querySelector('[data-technical]');
const technicalData = technicalDataEl
  ? JSON.parse(technicalDataEl.textContent)
  : {};
const API_HOST = technicalData.discountsApi;

const Discounts = () => {
  // eslint-disable-next-line no-unused-vars
  const [automaticDiscounts, setAutomaticDiscounts] = useState({
    discounts: {},
    products: {},
    variants: {},
    collections: {},
  });

  /**
   * Discount codes can be provided by session storage, `discount_code=` url
   * parameters, or the native shopify share links which put the code in a
   * cookie called `discount_code`.
   */
  function gatherDiscountCodes() {
    const discountCodes = [];

    // Check for a url parameter
    const url = new URL(document.location.href);
    const discountCodeParams = url.searchParams.get('discount_code');

    const cookieDiscount = getCookie('discount_code');
    if (cookieDiscount) discountCodes.push(cookieDiscount);

    if (discountCodeParams) {
      discountCodes.push(discountCodeParams);
      setCookie('discount_code', discountCodeParams, 2);
    }

    return discountCodes;
  }

  /**
   * Fetches all data needed for inline discounts
   */
  async function getActiveDiscounts() {
    const pathSuffix = window.STOREFRONT === 'LC' ? 'lc' : 'ml';
    // Fetch automatic discounts
    try {
      let url = `${API_HOST}/api/discounts/${pathSuffix}`;
      const codes = gatherDiscountCodes();
      if (codes.length > 0) {
        url = `${url}?discountCodes=${codes.join(',')}`;
      }
      const res = await fetch(url);
      const resJson = await res.json();
      setAutomaticDiscounts(resJson);
      window.automaticDiscounts = resJson;
      document.dispatchEvent(new CustomEvent('product-discounts:updated'));
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Unable to fetch automatic discounts.', error);
    }
  }

  useEffect(() => {
    // Fetch from API
    getActiveDiscounts();
  }, []);

  return null;
};

export default Discounts;
